import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'employeeAbsence';

const employeeAbsenceService = {
  getAbsences: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/absences`,
      data,
    });
  },

  createAbsence: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  updateAbsence: (data, id) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },

  deleteAbsence: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },
};

export default employeeAbsenceService;
